export enum ProductCategory {
  Moduler,
  Ordrer,
  "Flex ordrer",
  "Flex masseordrer",
}
